var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { types, flow, } from 'mobx-state-tree';
import _ from 'lodash';
import AzureContainerService from '../services/AzureContainerService';
import AzureStorageEntry from '../models/AzureStorageEntry';
var AzureStorageContainerStore = types
    .model({
    containerUriWithSas: types.string,
    entries: types.array(AzureStorageEntry),
    canLoadMore: types.optional(types.boolean, true),
    activePrefix: types.optional(types.string, ''),
    isLoading: types.optional(types.boolean, false)
})
    .named('AzureStorageContainerStore')
    .volatile(function () { return ({
    loadMoreToken: undefined,
}); })
    .views(function (self) { return ({
    get activeEntries() {
        var activeEntries = self.entries.filter(function (x) { return x.isDirectChildOf(self.activePrefix); });
        return _.orderBy(activeEntries, function (x) { return x.isBlob; });
    }
}); })
    .actions(function (self) { return ({
    loadMore: flow(function () {
        var entries, newEntries;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    self.isLoading = true;
                    return [4 /*yield*/, AzureContainerService.listContainer(self.containerUriWithSas, self.activePrefix)];
                case 1:
                    entries = _b.sent();
                    newEntries = entries.filter(function (x) { return !self.entries.find(function (y) { return y.isSame(x); }); });
                    (_a = self.entries).push.apply(_a, __spreadArray([], __read(newEntries), false));
                    self.isLoading = false;
                    return [2 /*return*/];
            }
        });
    }),
    setActivePrefix: function (activePrefix) {
        self.activePrefix = activePrefix;
    },
}); });
export default AzureStorageContainerStore;
//# sourceMappingURL=AzureStorageContainerStore.js.map